import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { ProcedureFromXPage } from './ProcedureFromX';

const ProcedureFromXPageBridge = react2angular(ProcedureFromXPage, [
  'creationType'
]);
export { ProcedureFromXPageBridge };
